import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import useSWR from 'swr';
import Header from 'components/Header';
import { ListPlaceholder } from 'components/Placeholders';
import EventList from 'components/EventList';
import useTitle from 'hooks/useTitle';

function Events() {
  useTitle('Eventos');

  const dispatch = useDispatch();
  const history = useHistory();

  const { data: events, error } = useSWR('/promoter/events', {
    onError: (error) => {
      if (error.response?.status === 401) {
        localStorage.removeItem('at');
        dispatch({ type: 'LOGOUT' });
        history.push('/');
      }
    },
  });

  if (error) console.log(error.response || error.message);

  return (
    <section id="events" className="page">
      <Header title="Relatórios" description="Acompanhe e gerencie suas vendas." />
      {error ? (
        <div className="alert alert-danger">
          Não foi possível carregar os eventos. Tente novamente.
        </div>
      ) : !events ? (
        <ListPlaceholder />
      ) : events.length === 0 ? (
        <div className="alert alert-info">Sua conta não está associada a nenhum evento.</div>
      ) : (
        <EventList events={events} linkTo={(event) => '/reports/dashboard/' + event.id} />
      )}
    </section>
  );
}

export default Events;
